import '../components/ubigeo';

$(()=> {
  console.log('demo');
  let apiAssignUser = '/carrito';

  let formCart = $('#form-cart');
  let formPayCart =$('#form-shipping-detail');
  let assignUserItem = $('.assign_user_item');

  let formShippingDetail = $('#form-shipping-detail');
  let btnFormCart = $('#btn-form-cart');

  // let message = $('.ui-message');

  let btnVisanet = $('.start-js-btn');
  btnVisanet.hide();

  function hideMessage(message, name) {
    setTimeout(() => {
      $(message).hide().removeClass(name).text('');
    }, 3000);
  }

  hideMessage();

  function messageError(message) {
    $(message).removeClass('ui-message--success').addClass('ui-message--error').fadeIn().text('Ha ocurrido un error, por favor inténtelo de nuevo');
    hideMessage(message, 'ui-message--error');
  }

  const assignUser = async (e)=> {

    let el = $(e.currentTarget);
    let productItem = el.parents('.product-item');
    let message = productItem.find('.ui-message');
    let number = el.data('id');
    let id = el.attr('name');
    let value = el.val();

    el.parent().removeClass('error');

    try {
      let response = await fetch(`${apiAssignUser}/${id}`, {
        method: 'PATCH',
        headers: {
          'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify( {value: value, number: number} )
      })

      if (!response.ok) {
        messageError(message);
        btnFormCart.attr('disabled', true);
        return;
      }

      let data = await response.json();

      if (data.success) {
        $(message).addClass('ui-message--success').fadeIn().text('Se agrego el usuario');
        hideMessage(message, 'ui-message--success');
        btnFormCart.removeAttr('disabled');
      } else {
        messageError(message);
        btnFormCart.attr('disabled', true);
      }

    } catch (error) {
      console.error('error: ', error);
    }
  }

  assignUserItem.on('change', assignUser);

  btnFormCart.on('click', (e)=> {
    e.preventDefault();

    let action = formCart.attr('action');
    let validSipping = formShippingDetail.valid();
    let valid = [];

    assignUserItem.parent().addClass('error')

    for ( let s of assignUserItem ) {
      if ( $(s).val() !== null ) {
        $(s).parent().removeClass('error');
        valid.push('true');
      }
    }

    if (valid.length == assignUserItem.length && validSipping ) {
      // console.log('ok');
      formPayCart.submit();
    }
  })

  $('#btnSendVN').on('click', (e)=> {
    e.preventDefault();

    const el = $(e.currentTarget);

    if ( el.parents('form').valid() ) {
      el.hide();
      btnVisanet.show();
    }
  });

  let chkVN = $('#form-shipment').find('input[type=checkbox]');

  chkVN.on('change', (e)=> {
    let cantCKK = chkVN.length;
    let countValid = [];

    for ( let inp of chkVN ) {
      if ( $(inp).is(':checked') ) {
        countValid.push('true');
      }
    }

    if ( countValid.length == cantCKK ) {
      $('#btnSendVN').hide();
      btnVisanet.show();
    } else {
      $('#btnSendVN').show();
      btnVisanet.hide();
    }

  });

});
